import styled from 'styled-components';
import DynamicCarrierField from './DynamicCarrierField';

export default styled(DynamicCarrierField)`
  width: 100%;
  .dynamic-carrier-field {
    input {
      height: auto;
      width: 100%;

      &--inline {
        height: 40px;
      }
    }

    &__field {
      width: 100%;
    }
  }
`;
